import Vue from 'vue'
import App from './App.vue'
import vuetify from './plugins/vuetify'
import { sunidhiPlugin } from './sunidhiapp';
import router from './router';
import Multiselect from 'vue-multiselect';


import '@/assets/styles/pwa-styles.min.css';

import '@/assets/styles/vue-multiselect.min.css';
import '@mdi/font/css/materialdesignicons.css';
import '@mdi/font/css/materialdesignicons.min.css';

// import '@/assets/styles/style.css';
// import '../node_modules/vuetify/dist/vuetify.min.css';

import '@/assets/styles/vuetify.min.css';
import '@/assets/styles/index.css';
import jic from './customJs/JIC.min.js';
import './customJs/canvasjs.min.js';
import './customJs/compressjs.js';
import $ from 'jquery';


Vue.config.productionTip = false;
// Vue.prototype.$sunidhi = sunidhi;
Vue.use(sunidhiPlugin);
Vue.component('vue-multiselect', Multiselect);
Vue.use(jic);

Vue.directive('hide', {
  inserted: function (el, binding) {
    el.style.display = binding.value ? 'none' : '';
  }
});

new Vue({
  vuetify,
  router,
  render: h => h(App),
  mounted() {
    window.addEventListener('beforeunload', (event) => {
      event.preventDefault();
      event.returnValue = '';
    });
  }
}).$mount('#app')

$(document).ready(function() {
  console.log('jQuery is ready');
});
